module.exports = __webpack_public_path__ + "img/pencil.9df89ec5.svg";